/**
 * @file: 卧柜列选择
 * @author: xiaolong.huang@dmall.com
 */

import ShortCutKey from '../../interaction/shortcutkey/index';
import Select from '../../interaction/select/index';

function init(): void {
    ShortCutKey.on({
        keyName: 'mousedown+c+mouseleft',
        callback: (ev: JQuery.MouseDownEvent): void => {
            Select.cabinetColSelect(ev);
        }
    });
}

export default {
    init
};
